/****************************************************************************
* Lazy loading
* https://github.com/ApoorvSaxena/lozad.js
****************************************************************************/

function fnLazyLoading() {

	// Exit if on Homepage (because vendor is not enqueued)
	if ( $( 'body' ).hasClass( 'home' ) ) return;

	/*****************
	* Initiate
	*****************/
	lozad( '.lozad', {
	    loaded: function( el ) {
	    	el.classList.add( 'loaded' );									// Add class
	    }
	} ).observe();

}


// END OF DOCUMENT
